



















import BaseComponent from '@/components/base-component.vue';
import { getNotificationPreview, getNotificationReading } from '@/services/notification';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {},
  directives: {},
})
export default class NotificationDialog extends BaseComponent {
  @Prop()
  id;

  @Prop()
  preview;

  @Prop()
  previewHtml;

  @Prop()
  previewTitle;

  @Prop()
  previewWidth;

  maxWidth = 850;

  dialogFlag = false;

  public $refs!: {
    form: HTMLFormElement;
  };

  notification = {};
  title = '';
  content = '';

  @Watch('previewHtml', { immediate: true })
  onPreviewHtmlChange(previewHtml) {
    if (!previewHtml) {
      return;
    }

    this.content = this.previewHtml;
    this.maxWidth = this.previewWidth;
    this.title = this.previewTitle;
    setTimeout(() => {
      this.dialogFlag = true;
      try {
        this.loadIframeContent();
      } catch(e){
        //nada
      }
    }, 300);
  }

  @Watch('id', { immediate: true })
  onIdChange(id) {
    if (!id) {
      return;
    }
    this.dialogFlag = false;
    this.loader.start('Processando');
    let obs = null;
    if (this.preview) {
      obs = getNotificationPreview(id);
    } else {
      obs = getNotificationReading(id);
    }
    obs.subscribe(
      (res) => {
        this.setNotification(res);
      },
      (error) => {
        this.setNotification({});
      },
    );
  }

  setNotification(res) {
    this.loader.stop();
    if (res && res.conteudoHtml) {
      this.notification = res;
      this.content = res.conteudoHtml;
      this.maxWidth = res.larguraMaxTemplate + 0;
      this.title = res.titulo;
      this.loader.stop();
      setTimeout(() => {
        this.dialogFlag = true;
        try {
          this.loadIframeContent();
        } catch(e){
          //nada
        }
      }, 300);
    } else {
      this.dialogFlag = false;
      this.dialog.show('alert', 'Notificação', 'Notificação não disponível');
      this.closeForm();
    }
  }

  loadIframeContent() {
    let iframe = this.$refs['iframeNotif'];
    iframe.contentWindow.document.open();
    iframe.contentWindow.document.write(this.content);
    iframe.contentWindow.document.close();
    iframe.onload = function() {
      iframe.style.height = iframe.contentWindow.document.documentElement.scrollHeight + 'px';
    };
  }

  closeForm() {
    this.$emit('close');
    this.dialogFlag = false;
  }
}
